import Multiselect from "./Multiselect";
import './multiselect.scss';

export default Multiselect;